import { RefObject, useEffect } from 'react';

import { getSelectedItemIdentifiers } from '../../../../../library/selection/selectors';
import { useAppSelector } from '../../../../hooks';
import { GridMethods } from '../DesignClientGrid';

// reveal a newly selected item, expanding its ancestors if needed.
export function GridAutoFocusPlugin({ gridRef }: { gridRef: RefObject<GridMethods | null> }) {
  const selectedItems = useAppSelector(getSelectedItemIdentifiers);

  useEffect(() => {
    if (selectedItems.length === 1) {
      gridRef.current?.focusRow(selectedItems[0]);
    }
  }, [gridRef, selectedItems]);

  return null;
}
